module.exports = __webpack_public_path__ + "static/tv200sport-dd5969d169e452e8f6d9a6cb2eef1c18.svg";